module.exports = __webpack_public_path__ + "static/media/WXRWYR2.d77068ef.png";